import { Box } from "@chakra-ui/react";
import { MailDocument } from "core";
import {
  collection,
  CollectionReference,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import React from "react";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import TableCard from "../../../../components/TableCard";
import { WithId } from "../../../../types/utils";
import MailRow, { columnNames as mailColumnNames } from "../MailRow";

interface Props {
  email: string;
}

export default function EmailTab({ email }: Props) {
  const firestore = useFirestore();
  const mailQuery = query(
    collection(firestore, "mail") as any,
    where("to", "==", email),
    orderBy("delivery.startTime", "desc")
  );
  const { data: mailsData = [] } = useFirestoreCollectionData(mailQuery as any, {
    idField: "id",
  });
  const mails = mailsData as any[];

  return (
    <Box>
      {/* @ts-ignore - Complex Zod/Chakra type inference issue */}
      <TableCard columnNames={mailColumnNames} title="Mail">
        {mails.map((mail: any) => (
          <MailRow
            key={mail.id}
            mail={mail}
            isLast={mail.id === mails[mails.length - 1].id}
          />
        ))}
      </TableCard>
    </Box>
  );
}
